import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: 'button',
  standalone: false
})
export class InputGroupFocusRemoverDirective {
  constructor(private elRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('click') onClick() {
    this.elRef.nativeElement.blur();
  }
}
